import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchAdmin } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import ViewAdmin from '../components/admins/ViewAdmin';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  admin: PropTypes.object,
  adminId: PropTypes.string.isRequired,
  query: PropTypes.object,
};

class AdminViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchAdmin(this.props.adminId));
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="admins component" style={authPage}>
        <h2>View Admin</h2>
        <div className="content">
          <ViewAdmin
            admin={this.props.admin}
          />
        </div>
      </div>
    );
  }
}

AdminViewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

AdminViewPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    admin: state.admins.admin,
    adminId: ownProps.params.id,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(AdminViewPage));



// WEBPACK FOOTER //
// ./src/containers/AdminViewPage.js